if (!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      if (!this.hasAttribute('available')) return;

      this.refreshHandler = this.handleRefreshBtnClick.bind(this);
      this.unavailableHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);

      this.getAvailability(this.dataset.variantId);
    }

    /**
     * Handles 'click' events on the refresh button.
     */
    handleRefreshBtnClick() {
      this.getAvailability(this.dataset.variantId);
    }

    /**
     * Gets pick up availability for the current variant.
     * @param {string} variantId - Current variant id.
     */
    async getAvailability(variantId) {
      let { rootUrl } = this.dataset;
      if (!rootUrl.endsWith('/')) rootUrl = `${rootUrl}/`;

      try {
        const response = await fetch(`${rootUrl}variants/${variantId}/?section_id=pickup-availability`);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        this.renderPickupInfo(tmpl.content.querySelector('.shopify-section'));
      } catch (error) {
        const refreshBtn = this.querySelector('.js-refresh');
        if (refreshBtn) refreshBtn.removeEventListener('click', this.refreshHandler);
        this.renderUnavailableMsg();
      }
    }

    /**
     * Renders the pick up info.
     * @param {Element} sectionHtml - Fetched section HTML element.
     */
    renderPickupInfo(sectionHtml) {
      // Remove any existing drawer
      const existingDrawer = document.querySelector('.js-pickup-drawer');
      if (existingDrawer) existingDrawer.remove();

      // No pickup status found — clear and mark unavailable
      if (!sectionHtml || !sectionHtml.querySelector('.pickup-status')) {
        this.innerHTML = '';
        this.removeAttribute('available');
        return;
      }

      // Render the inline status block
      this.setAttribute('available', '');
      this.innerHTML = sectionHtml.querySelector('.pickup-status').outerHTML;

      // Append drawer to body if present
      const drawer = sectionHtml.querySelector('.js-pickup-drawer');
      if (drawer) document.body.appendChild(drawer);

      // Wire up the "view store info / check other stores" button
      const showDetailsBtn = this.querySelector('.js-show-pickup-info');
      if (showDetailsBtn) {
        showDetailsBtn.addEventListener('click', () => {
          const pickupDrawer = document.querySelector('.js-pickup-drawer');
          if (pickupDrawer) pickupDrawer.open(showDetailsBtn);
        });
      }
    }

    /**
     * Renders a 'pick up unavailable' fallback message with a refresh button.
     */
    renderUnavailableMsg() {
      this.innerHTML = '';
      this.appendChild(this.unavailableHtml);

      const refreshBtn = this.querySelector('.js-refresh');
      if (refreshBtn) refreshBtn.addEventListener('click', this.refreshHandler);
    }
  }

  customElements.define('pickup-availability', PickupAvailability);
}